import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import Data from '../../../../data/StateDeedOfAbsoluteSale.json';
import FormError from '../../../../view/FormError';
import Meta from '../../../../model/Meta';

class DeedOfAbsoluteSaleStep5 extends Component {
    constructor(props) {
        super(props);

        this.state = Data;

        this.handleRadioChange = this.handleRadioChange.bind(this);
    }

    componentWillMount() {

		if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
					//console.log("State default: ", this.state);
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));

					// Initialize errors and callbacks
					this.errorHandle();

				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
			//console.log("State default: ", this.state);
			//console.log("Storage default: ", data);
		}

    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

	handleRadioChange(e, radioname) {

		/**
		 * Passing name props for radio buttons
		 * Having issues with radio buttons when in array map
         * @ radioname String
		 */		
		const target = e.target;
		const value = target.value;
		const name = radioname

		this.setState({
			details: {
				property: this.state.details.property,
				seller: this.state.details.seller,
				buyer: this.state.details.buyer,
				payment: {
                    ...this.state.details.payment,
                    [name]: value
                }
			},
			formFocus: `payment_${name}`
		},
			()=>{
				//console.log("Handle user change: ", this.state);
				console.log("Focus target: ", this.state.formFocus);
				this.setState(this.state);
				localStorage.setItem(this.state.formId, JSON.stringify(this.state));
				this.errorHandle();

			}
		);
	}
    
    errorHandle(callback = null) {
        let errorArray = [];

        if(
            this.state.details.property.earnestMoneyAmount==="" ||
            this.state.details.property.price==="" ||
            this.state.details.property.daysReserved===""
            ) {
            let err = {
                "message": `All fields are required.`
            }
            errorArray.push(err);
        } 

        ////console.log("Going to state: ", errorArray)
        this.setState({
            formError: errorArray
        },(i)=>{
            ////console.log("Error handle: ", this.state )
            localStorage.setItem(this.state.formId, JSON.stringify(this.state));
            this.checkCompleteness();	
            this.elementsShowHide();	
        })

    }

    checkCompleteness() {

		if(this.state.formError.length>0) {
            $(".next").addClass("disabled");
            $(".form-error").removeClass("d-none");
		} else {
            $(".next").removeClass("disabled");
            $(".form-error").addClass("d-none");
		}
			
    }

    elementsShowHide() {
        this.state.details.payment.hasBroker==="No" ?
            $(".payment-broker-commission").addClass("d-none") :
            $(".payment-broker-commission").removeClass("d-none");
    }

    render() {
        const meta = {
			title: "Capital Gains Tax information - Deed of Absolute Sale Contract",
			description: "Enter Capital Gains Tax information to create your custom Deed of Absolute Sale Contract"
		}
        return (
            <div className="page page-inner page-contract">
                <Meta {...meta}/>
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
								
                                <ContractCreate />
								
								<ProgressBar percentage={Math.floor((5/6)*100)} />

                                <form>
                                    <div className="payment-cgt">
                                        <p className="label"><strong>Who pays for the capital gains tax (CGT)? In practice, it is the seller.<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="seller" 
                                                            onChange={(e)=>this.handleRadioChange(e, "capitalGainTax")}
                                                            checked={this.state.details.payment.capitalGainTax === 'seller'} 
                                                        />
                                                            Seller
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="buyer" 
                                                            onChange={(e)=>this.handleRadioChange(e, "capitalGainTax")}
                                                            checked={this.state.details.payment.capitalGainTax === 'buyer'} 
                                                        />
                                                            Buyer
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                    <br />

                                    <div className="payment-documentary-stamp-tax">
                                        <p className="label"><strong>Who pays for the documentary stamp tax (DST)? In practice, it is the buyer.<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="seller" 
                                                            onChange={(e)=>this.handleRadioChange(e, "documentaryStampTax")}
                                                            checked={this.state.details.payment.documentaryStampTax === 'seller'} 
                                                        />
                                                            Seller
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="buyer" 
                                                            onChange={(e)=>this.handleRadioChange(e, "documentaryStampTax")}
                                                            checked={this.state.details.payment.documentaryStampTax === 'buyer'} 
                                                        />
                                                            Buyer
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                    <br />

                                    <div className="payment-transfer-tax">
                                        <p className="label"><strong>Who pays for the transfer tax? In practice, it is the buyer.<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="seller" 
                                                            onChange={(e)=>this.handleRadioChange(e, "transferTax")}
                                                            checked={this.state.details.payment.transferTax === 'seller'} 
                                                        />
                                                            Seller
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="buyer" 
                                                            onChange={(e)=>this.handleRadioChange(e, "transferTax")}
                                                            checked={this.state.details.payment.transferTax === 'buyer'} 
                                                        />
                                                            Buyer
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                    <br />

                                    <div className="payment-registration-fee">
                                        <p className="label"><strong>Who pays for the registration fee? In practice, it is the buyer.<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="seller" 
                                                            onChange={(e)=>this.handleRadioChange(e, "registrationFee")}
                                                            checked={this.state.details.payment.registrationFee === 'seller'} 
                                                        />
                                                            Seller
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="buyer" 
                                                            onChange={(e)=>this.handleRadioChange(e, "registrationFee")}
                                                            checked={this.state.details.payment.registrationFee === 'buyer'} 
                                                        />
                                                            Buyer
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                    <br />

                                    <div className="payment-notarial-fee">
                                        <p className="label"><strong>Who pays for the notarial fee? In practice, it is the buyer.<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="seller" 
                                                            onChange={(e)=>this.handleRadioChange(e, "notarialFee")}
                                                            checked={this.state.details.payment.notarialFee === 'seller'} 
                                                        />
                                                            Seller
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="buyer" 
                                                            onChange={(e)=>this.handleRadioChange(e, "notarialFee")}
                                                            checked={this.state.details.payment.notarialFee === 'buyer'} 
                                                        />
                                                            Buyer
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                    <br />

                                    <div className="payment-has-broker">
                                        <p className="label"><strong>Is there a real state broker in the transaction?<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="Yes" 
                                                            onChange={(e)=>this.handleRadioChange(e, "hasBroker")}
                                                            checked={this.state.details.payment.hasBroker === 'Yes'} 
                                                        />
                                                            Yes
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="No" 
                                                            onChange={(e)=>this.handleRadioChange(e, "hasBroker")}
                                                            checked={this.state.details.payment.hasBroker === 'No'} 
                                                        />
                                                            No
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                    <br />

                                    <div className="payment-broker-commission">
                                        <p className="label"><strong>Who pays for the broker's commission? In practice, it is the buyer.<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="seller" 
                                                            onChange={(e)=>this.handleRadioChange(e, "brokerCommission")}
                                                            checked={this.state.details.payment.brokerCommission === 'seller'} 
                                                        />
                                                            Seller
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="buyer" 
                                                            onChange={(e)=>this.handleRadioChange(e, "brokerCommission")}
                                                            checked={this.state.details.payment.brokerCommission === 'buyer'} 
                                                        />
                                                            Buyer
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                    <br />

                                    <div className="payment-creditable-withholding-tax">
                                        <p className="label"><strong>In case the real property is categorized by the BIR as an ordinary asset, creditable withholding tax (CWT) shall be imposed in lieu of the capital gains tax (CGT).Who pays for the CWT? In practice, it is the seller.<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="seller" 
                                                            onChange={(e)=>this.handleRadioChange(e, "creditableWithholdingTax")}
                                                            checked={this.state.details.payment.creditableWithholdingTax === 'seller'} 
                                                        />
                                                            Seller
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="buyer" 
                                                            onChange={(e)=>this.handleRadioChange(e, "creditableWithholdingTax")}
                                                            checked={this.state.details.payment.creditableWithholdingTax === 'buyer'} 
                                                        />
                                                            Buyer
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                    <br />

                                    <div className="payment-value-added-tax">
                                        <p className="label"><strong>In case the real property is categorized by the BIR as an ordinary asset, value added tax (VAT) shall likewise be imposed. Who pays for the VAT? In practice, VAT is included in the purchase price, hence, it is the seller.<span className="red asterisk">*</span></strong></p>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="form-check form-check-inline mr-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio"
                                                            value="seller" 
                                                            onChange={(e)=>this.handleRadioChange(e, "valueAddedTax")}
                                                            checked={this.state.details.payment.valueAddedTax === 'seller'} 
                                                        />
                                                            Seller
                                                        </label>
                                                </div>
                                            </div>
                                            <div className="col-6">
                                                <div className="form-check form-check-inline ml-2">
                                                    <label className="form-check-label">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            value="buyer" 
                                                            onChange={(e)=>this.handleRadioChange(e, "valueAddedTax")}
                                                            checked={this.state.details.payment.valueAddedTax === 'buyer'} 
                                                        />
                                                            Buyer
                                                        </label>
                                                </div>
                                            </div>
                                        </div>
									</div>

                                </form>

                                {/** Navs */}
								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 5/6</p>
									<FormError errors={this.state.formError} />
									<div className="row">
										<div className="col-6">
											<Link to={this.state.formPath+"/4"} className="btn btn-lightblue w-100">Back</Link>
										</div>
										<div className="col-6">
											<Link to={this.state.formPath+"/6"} className="btn btn-lightblue disabled next w-100">Next</Link>
										</div>
									</div>
								</div>

                            </div>
                            
                            <div className="col-12 col-md-7 right-preview">
								<Preview {...this.state} />
							</div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DeedOfAbsoluteSaleStep5;


// WEBPACK FOOTER //
// ./src/pages/contracts/real-estate/deed-of-absolute-sale/DeedOfAbsoluteSaleStep5.js